<template>
  <div class="contant">
    <div class="mong">
      <div class="mong_c">
      <div class="page-account-top">
        <div class="page-account-top-logo">
          <img src="../../../static/img/dang.png" alt="logo"/>
          <div class="page-account-top-logo-c">
            <h2>智慧党建云发系统</h2>
            <h5>融合 集约 智能 高效 </h5>
          </div>
        </div>
      </div>
      <div class="from">
        <Form ref="formInline" :model="formInline" :rules="ruleInline" label-position="left">
          <FormItem prop="username">
            <Input type="text" v-model="formInline.username" size="large" placeholder="请输入用户名">
            <Icon type="ios-person-outline" slot="prepend"></Icon>
            </Input>
          </FormItem>
          <FormItem prop="password">
            <Input type="password" v-model="formInline.password" size="large" placeholder="请输入密码">
            <Icon type="ios-lock-outline" slot="prepend"></Icon>
            </Input>
          </FormItem>
          <FormItem>
            <CheckboxGroup >
              <Checkbox v-model="formInline.checkbox" label="自动登录"></Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem>
            <Button type="primary" size="large" class="submit" @click="handleSubmit('formInline')">登录</Button>
          </FormItem>
        </Form>
      </div>
     </div>
    </div>

   <footer class="ivu-global-footer i-copyright">
      <div class="ivu-global-footer-links">
        <a href="#" target="_blank" title="社区">
          山东鲁兴国际人才科技有限公司 版权所有</a>
      </div>
      <div class="ivu-global-footer-links">
        技术支持：
        <a href="https://www.shengjiahd.com/front/#/" target="_blank" title="青岛胜加互动科技">
          青岛胜加互动科技</a>
      </div>
      <div class="ivu-global-footer-copyright">智慧媒体融合技术由鲁兴国际媒体云强力驱动</div>
    </footer>
  </div>

</template>

<script>
import { Login } from '../../api/user_api'
export default {
  data () {
    return {
      formInline: {
        username: '',
        password: '',
        checkbox: false
      },
      ruleInline: {
        username: [{
          required: true,
          message: '请输入用户名！',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码！',
          trigger: 'blur'
        },
        {
          type: 'string',
          min: 6,
          message: '密码长度不得少于6位数！',
          trigger: 'blur'
        }
        ]
      }
    }
  },
  beforeCreate: function () {
    const token = sessionStorage.getItem('token')
    if (token !== null || token == '') {
      window.location.href = '/'
    }
  },

  methods: {
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          Login(this.formInline).then(res => {
            if (res.data.ret == 200) {
              this.$Message.success('登录成功!')
              console.log(res.data.data)
              sessionStorage.setItem('id', res.data.data.id)
              sessionStorage.setItem('department', res.data.data.department)
              sessionStorage.setItem('is_delete', res.data.data.is_delete)
              sessionStorage.setItem('realname', res.data.data.realname)
              sessionStorage.setItem('role_id', res.data.data.role_id)
              sessionStorage.setItem('role_name', res.data.data.role_name)
              sessionStorage.setItem('token', res.data.data.token)
              sessionStorage.setItem('username', res.data.data.username)
              var _this = this
              setTimeout(function () {
                _this.$router.push({ path: '/index/tongji' })
              }, 1000)
            }
          })
        } else {
          this.$Message.error('请输入用户名和密码!')
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .contant {
    width: 100%;
    height: 100%;
    background-image: url(../../../static/img/5332.jpg);
    background-repeat: no-repeat;
    background-position: 50%;
    background-size:cover;
  }
  .mong{
    width: 100%;
    padding-top: 10%;
  }
  .mong_c{
    width:500px;
    height: 430px;
    border-radius: 20px;
    background-color: #FFFFFF;
    margin: 0px auto 0 auto;
  }

  .from {
    width: 390px;
    height: 500px;
    margin: 0 auto;
    padding-top: 32px;
  }

  .submit {
    width: 390px;
  }

  .ivu-checkbox-group-item {
    float: left;
  }

  .ivu-global-footer {
    width: 100%;
    position: fixed;
    bottom: 40px;
  }

  .ivu-global-footer-copyright {
    color: #fff;
    font-size: 14px;
  }

  .ivu-global-footer-links {
    margin-bottom: 8px;
  }

  .ivu-global-footer-links a {
    font-size: 14px;
    color: #fff;
    -webkit-transition: all .2s ease-in-out;
    transition: all .2s ease-in-out;
  }

  .ivu-global-footer-links a:not(:last-child) {
    margin-right: 40px;
  }

 .page-account-top {
   width: 280px;
   height: 100px;
   margin: 0 auto;
   padding: 44px 0 0px 0;
}

.page-account-top-logo {
  width: 280px;
  height: 60px;
  padding-left: 20px;
  img {
      height: 45px;
      float: left;
      margin-right: 10px;
  }
  span{
    line-height: 60px;
    font-size: 20px;
    font-weight: bold;
    float: left;
  }
}
.page-account-top-desc {
    font-size: 14px;
    color: #fff;
}
.page-account-top-logo-c{
  text-align: left;
  h2{
    font-weight: 400;
    line-height:35px;
    color: #333;
  }
  h5{
    font-weight: 400;
    color: #666;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/login.vue